export enum TokenKey {
    DermaSnel = '8512d5437d00448a94a94e06e1fe61c4',
}
